export interface VehicleColor {
    id: number;
    name: string;
}

export const VEHICLE_COLORS: VehicleColor[] = [
    // { id: 0, name: "Unknown" },
    { id: 1, name: "White" },
    { id: 2, name: "Black" },
    { id: 3, name: "Silver" },
    { id: 4, name: "Gray" },
    { id: 5, name: "Blue" },
    { id: 6, name: "Red" },
    { id: 7, name: "Green" },
    { id: 8, name: "Yellow" },
    { id: 9, name: "Orange" },
    { id: 10, name: "Brown" },
    { id: 11, name: "Purple" },
    { id: 12, name: "Gold" },
    { id: 13, name: "Beige" },
    { id: 14, name: "Other" }
];